import React, { useContext } from "react";

import { Icon } from "@culturehq/components";

import AccordianCaptions from "components/common/AccordianCaptions";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import { Trans } from "app/utils";
import downloadCaptions from "../../utils/downloadCaptions";

const DownloadOption: React.FC<{}> = () => {
  const { data: { subtitles } } = useContext(CreatomateContext);

  const accordionOptions = [
    {
      className: "DownloadDp-Option caption-div",
      content: (
        <>
          <Icon icon="download" />
          <Trans>Download Subtitles(VTT)</Trans>
        </>
      ),
      onClick: () => downloadCaptions("vtt", subtitles)
    },
    {
      className: "DownloadDp-Option caption-div",
      content: (
        <>
          <Icon icon="download" />
          <Trans>Download Subtitles(SRT)</Trans>
        </>
      ),
      onClick: () => downloadCaptions("srt", subtitles)
    }
  ];

  return (
    <div className="DownloadDp-Option accordion-header">
      <AccordianCaptions accordionOptions={accordionOptions} />
    </div>
  );
};

export default DownloadOption;
